module.exports = __webpack_public_path__ + "img/step_3-8.e15e6ea8.png";